import IBoardData from "./interfaces/IBoardData";

class Boards {

  private mPath: string;
  private mBoards: { [id: string]: IBoardData };

  public constructor(path: string) {
    this.mPath = path;
    this.mBoards = {};
  }

  public request(): Promise<string | void> {
    return fetch(this.mPath)
      .then((response: Response) => response.json())
      .then((json: IBoardData[]) => {
        this.mBoards = {};

        for (let child of json) {
          // Use the first override name if it exists
          if (child.OverrideNames != null) {
            if (child.OverrideNames.length > 0) {
              child.Name = child.OverrideNames[0];
            }
          }

          this.mBoards[child.ID] = child;
        }

        return new Promise<string>(
          (resolve, reject) => {
            resolve("Fetching Boards ready!");
            reject("Fetching Boards failed!");
          },
        );
      })
      .catch((error: any) => {
        console.error("Error loading JSON:", error);
      });
  }

  public findByID(id: string): IBoardData | null {
    const child = this.mBoards[id];
    return (child ? child : null);
  }

  public first(): IBoardData | null {
    const first = this.mBoards[Object.keys(this.mBoards)[0]];
    return (first ? first : null);
  }

  public children(): IBoardData[] {
    return Object.values(this.mBoards);
  }
}

export default Boards;
